export default __webpack_public_path__ + "static/media/table_cancer_screening_HK.0a9023bc.webp";